import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { getRequest, putRequest } from '../../requestUtils';
import ProjectLoadingIndicator from '../ProjectDetails/ProjectLoadingIndicator';
import ExpertiseTagDropdown from '../common/ExpertiseTagDropdown';
var models = ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'];
var formStep = 'qualifications';
var maxItems = 100;
var filterPicklist = function filterPicklist(picklist, input) {
  return picklist.filter(function (record) {
    return record.label.toLowerCase().includes(input.toLowerCase());
  }).slice(0, maxItems);
};
var SuggestedQualificationsModal = /*#__PURE__*/function (_Component) {
  function SuggestedQualificationsModal(props) {
    var _this;
    _classCallCheck(this, SuggestedQualificationsModal);
    _this = _callSuper(this, SuggestedQualificationsModal, [props]);
    _defineProperty(_this, "applySuggestionsIfAny", function () {
      var suggestedTagLabels = _this.props.suggestedTagLabels;
      var _this$state = _this.state,
        expertiseTags = _this$state.expertiseTags,
        expertisePicklists = _this$state.expertisePicklists,
        notApplicable = _this$state.notApplicable;
      if (!suggestedTagLabels || !expertisePicklists || !expertiseTags) return;
      var updated = _objectSpread({}, expertiseTags);
      var labelToId = function labelToId(model, label) {
        var pick = (expertisePicklists[model] || []).find(function (opt) {
          return opt.label === label;
        });
        if (pick) return pick.value;
        // Skills is the only creatable model, so unmatched suggestions become "Other
        // Keywords / Skills" chips instead of being dropped like the closed picklists.
        return model === 'skill' ? "custom:".concat(label) : null;
      };
      models.forEach(function (model) {
        var labels = suggestedTagLabels[model];
        if (!labels || notApplicable.includes(model)) return;
        var ids = labels.map(function (l) {
          return labelToId(model, l);
        }).filter(function (v) {
          return v !== null;
        });
        if (ids.length === 0) return;
        var current = Array.isArray(updated["".concat(model, "_ids")]) ? updated["".concat(model, "_ids")] : [];
        if (model === 'area_of_expertise') {
          updated["".concat(model, "_ids")] = ids.length ? [ids[0]] : current;
        } else {
          updated["".concat(model, "_ids")] = Array.from(new Set([].concat(_toConsumableArray(current || []), _toConsumableArray(ids))));
        }
      });
      _this.setState({
        expertiseTags: updated
      });
    });
    _defineProperty(_this, "handleSelect", function (model, multi) {
      return function (tags) {
        var expertiseTags = _this.state.expertiseTags;
        var all = _objectSpread({}, expertiseTags);
        if (multi) {
          all["".concat(model, "_ids")] = tags.map(function (t) {
            return t.value;
          });
        } else {
          all["".concat(model, "_ids")] = tags.length >= 1 ? [tags[tags.length - 1].value] : [];
        }
        _this.setState({
          expertiseTags: all
        });
      };
    });
    _defineProperty(_this, "handleCreate", function (model, multi) {
      return function (inputValue) {
        var expertiseTags = _this.state.expertiseTags;
        var all = _objectSpread({}, expertiseTags);
        if (multi) {
          all["".concat(model, "_ids")].push("custom:".concat(inputValue));
        } else {
          all["".concat(model, "_ids")] = ["custom:".concat(inputValue)];
        }
        _this.setState({
          expertiseTags: all
        });
      };
    });
    _defineProperty(_this, "handleSave", function () {
      var _this$props = _this.props,
        csrfToken = _this$props.csrfToken,
        projectResourceId = _this$props.projectResourceId,
        onSaved = _this$props.onSaved;
      var _this$state2 = _this.state,
        expertiseTags = _this$state2.expertiseTags,
        notApplicable = _this$state2.notApplicable,
        localMode = _this$state2.localMode,
        expertisePicklists = _this$state2.expertisePicklists;
      var projectAttributes = _objectSpread({}, expertiseTags);
      models.forEach(function (model) {
        if (model === 'therapy') {
          projectAttributes.therapies_not_applicable = notApplicable.includes(model);
        } else {
          projectAttributes["".concat(model, "s_not_applicable")] = notApplicable.includes(model);
        }
      });
      _this.setState({
        saving: true
      });
      if (!localMode && projectResourceId) {
        putRequest("/projects/".concat(projectResourceId, "?form_step=qualifications"), {
          project: projectAttributes
        }, csrfToken).then(function () {
          _this.setState({
            saving: false
          });
          onSaved();
        })["catch"](function () {
          return _this.setState({
            saving: false
          });
        });
      } else {
        // Local mode: hand selections to parent, do not persist yet
        _this.setState({
          saving: false
        });
        onSaved({
          expertiseTags: projectAttributes,
          notApplicable: notApplicable,
          expertisePicklists: expertisePicklists
        });
      }
    });
    _this.state = {
      loading: true,
      expertiseTags: null,
      expertisePicklists: {},
      notApplicable: [],
      saving: false,
      localMode: false
    };
    return _this;
  }
  _inherits(SuggestedQualificationsModal, _Component);
  return _createClass(SuggestedQualificationsModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;
      if (isOpen && !prevProps.isOpen) {
        this.loadData();
      }
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this2 = this;
      var projectResourceId = this.props.projectResourceId;
      this.setState({
        loading: true
      });
      if (projectResourceId) {
        getRequest("/projects/".concat(projectResourceId, "?form_step=").concat(formStep)).then(function (_ref) {
          var data = _ref.data;
          _this2.setState({
            expertiseTags: data.expertise_tags,
            expertisePicklists: data.expertise_picklists || {},
            notApplicable: data.not_applicable,
            loading: false,
            localMode: false
          }, _this2.applySuggestionsIfAny);
        });
      } else {
        // Local mode: fetch picklists only, initialize empty selections
        getRequest('/projects/expertise_picklists').then(function (_ref2) {
          var data = _ref2.data;
          var picklists = data.expertise_picklists || {};
          var blank = {};
          models.forEach(function (m) {
            blank["".concat(m, "_ids")] = [];
          });
          _this2.setState({
            expertiseTags: blank,
            expertisePicklists: picklists,
            notApplicable: [],
            loading: false,
            localMode: true
          }, _this2.applySuggestionsIfAny);
        });
      }
    }
  }, {
    key: "renderSelect",
    value: function renderSelect(model, heading, asyncUrl, isCreate, multi, notApplicableCheckbox) {
      var _this$state3 = this.state,
        expertiseTags = _this$state3.expertiseTags,
        notApplicable = _this$state3.notApplicable,
        expertisePicklists = _this$state3.expertisePicklists;
      var picklist = expertisePicklists[model] || [];
      var selection = expertiseTags["".concat(model, "_ids")].map(function (id) {
        var foundOption = picklist.find(function (option) {
          return option.value === id;
        });
        return foundOption || (typeof id === 'string' ? {
          label: id.slice(7),
          value: id
        } : undefined);
      }).filter(Boolean);
      var disabled = notApplicable.includes(model);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(model)
      }, /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
        model: model,
        selection: selection,
        handleSelect: this.handleSelect,
        handleCreate: this.handleCreate,
        multi: multi,
        isValidNewOption: function isValidNewOption() {
          return isCreate;
        },
        isCreatable: isCreate,
        heading: heading,
        isDisabled: disabled,
        picklist: picklist,
        loadOptions: function loadOptions(input) {
          return new Promise(function (resolve) {
            resolve(filterPicklist(picklist, input));
          });
        },
        groupStyle: model === 'degree'
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$state4 = this.state,
        loading = _this$state4.loading,
        expertiseTags = _this$state4.expertiseTags;
      if (loading || !expertiseTags) return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-expertise-container"
      }, /*#__PURE__*/React.createElement("h2", null, "Qualifications"), /*#__PURE__*/React.createElement("div", {
        className: "heading-subtext mb-3"
      }, "Select qualifications and skills required for your project"), this.renderSelect('area_of_expertise', 'Functional Areas', '', false, false, false), this.renderSelect('therapeutic_area', 'Therapeutic Areas', '', false, true, false), this.renderSelect('disease_code', 'Diseases and indications', '/users/autocomplete_disease_code', false, true, false), this.renderSelect('therapy', 'Product Technologies', '', false, true, false), this.renderSelect('regulatory_pathway', 'Regulatory Pathways', '', false, true, false), this.renderSelect('development_phase', 'Development Phases', '', false, true, false), this.renderSelect('degree', 'Highest Education', '', false, true, false), this.renderSelect('language', 'Language', '', false, true, false), this.renderSelect('accreditation', 'Certification', '', false, true, false), this.renderSelect('skill', 'Other Keywords / Skills', '', true, true, false));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isOpen = _this$props2.isOpen,
        onClose = _this$props2.onClose;
      var saving = this.state.saving;
      return /*#__PURE__*/React.createElement(Modal, {
        show: isOpen,
        onHide: onClose,
        dialogClassName: "add-coworkers-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "qualifications-modal-body"
      }, this.renderContent(), /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: onClose
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSave,
        disabled: saving
      }, saving ? 'Saving…' : 'Save'))));
    }
  }]);
}(Component);
SuggestedQualificationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  projectResourceId: PropTypes.string,
  // optional in local (no-project) mode
  csrfToken: PropTypes.string.isRequired,
  suggestedTagLabels: PropTypes.shape({})
};
SuggestedQualificationsModal.defaultProps = {
  projectResourceId: null,
  suggestedTagLabels: undefined
};
export default SuggestedQualificationsModal;